import apiClient from "./axiosInstanceStock";

export const getStockByProccesingPlantId = async (id) => {
  if (!id) {
    throw new Error('Stock ID is required');
  }
  return await apiClient.get(`/getstockByProccesing/${id}`);
};
